import "./style.scss";

const Button = ({
  children,
  variant = "primary", // back | gradient
  onClick,
  type = "button",
  disabled = false,
  fullWidth = false,
  size,
  className,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn btn-${variant} ${size ? `btn-${size}` : ""} ${fullWidth ? "w-100" : ""} text-white fs-7 ${className || ""}`}
    >
      {children}
    </button>
  );
};

export default Button;